export const isWebExtension = (): boolean => {
  // Check if we're running in an iframe
  const isIframe = window.self !== window.top;

  // Check if we have access to chrome.runtime
  const hasChromeRuntime = typeof chrome !== "undefined" && chrome.runtime;

  // Check ancestor origins for chrome-extension:// protocol
  const hasExtensionAncestor = (() => {
    try {
      return Array.from(location.ancestorOrigins).some(origin => 
        origin.startsWith('chrome-extension://')
      );
    } catch (e) {
      return false;
    }
  })();

  return isIframe && hasChromeRuntime && hasExtensionAncestor;
};

export const isMobileApp = (): boolean => {
  return typeof window !== "undefined" && (window as any).ReactNativeWebView;
};

export type MobilePlatform = "ios" | "android";

export const getMobileAppPlatform = (): MobilePlatform | null => {
  if (typeof window === "undefined") return null;
  try {
    const tag = (window as any).SHARPANA_UA_TAG as string | undefined;
    if (tag?.includes("SharpanaApp-iOS")) return "ios";
    if (tag?.includes("SharpanaApp-Android")) return "android";
  } catch {}
  try {
    const ua = navigator.userAgent || "";
    if (ua.includes("SharpanaApp-iOS")) return "ios";
    if (ua.includes("SharpanaApp-Android")) return "android";
  } catch {}
  return null;
};